module.exports = __webpack_public_path__ + "static/media/advanced.09018af7.png";